import { useState, useEffect } from 'react'
import { supabase } from './supabase'

const NAV_ITEMS = [
  { id: 'home', icon: '⌂', label: 'Home' },
  { id: 'match_schedule', icon: '◷', label: 'Schedule' },
  { id: 'crossbet_picker', icon: null, label: 'CROSSBET', special: true },
  { id: 'invites', icon: '✉', label: 'Invites' },
  { id: 'wallet', icon: '◈', label: 'Wallet' },
]

const SCREEN_NAV = {
  home: 'home', match_schedule: 'match_schedule', match_lobby: 'match_schedule',
  invite_players: 'match_schedule', create_match: 'crossbet_picker',
  crossbet_picker: 'crossbet_picker', one_v_one: 'crossbet_picker', sport_picker: 'crossbet_picker',
  profile: 'home', golf_profile: 'home',
  invites: 'invites', wallet: 'wallet', scorecard: 'match_schedule',
}

const SCREEN_TITLES = {
  home: 'CROSSBET', match_schedule: 'MY MATCHES', match_lobby: 'MATCH LOBBY',
  invite_players: 'INVITE PLAYERS', create_match: 'CREATE MATCH',
  crossbet_picker: 'CROSSBET', sport_picker: 'SELECT SPORT',
  profile: 'MY PROFILE', golf_profile: 'GOLF PROFILE',
  invites: 'INVITES', one_v_one: '1V1 CROSSBET', betting_ledger: 'BETTING LEDGER', wallet: 'WALLET', scorecard: 'SCORECARD', golf_stats: 'GOLF STATS',
}

export default function Layout({ screen, children, onNavigate, onBack, showBack, session }) {
  const [menuOpen, setMenuOpen] = useState(false)
  const [matchProfilesOpen, setMatchProfilesOpen] = useState(false)
  const [servicesOpen, setServicesOpen] = useState(false)
  const [profile, setProfile] = useState(null)
  const activeNav = SCREEN_NAV[screen] || 'home'
  const title = SCREEN_TITLES[screen] || 'CROSSBET'

  useEffect(() => {
    if (!session) return
    supabase.from('profiles').select('first_name, last_name, avatar_url').eq('id', session.user.id).single().then(({ data }) => {
      if (data) setProfile(data)
    })
  }, [session])

  const initials = profile ? profile.first_name?.charAt(0).toUpperCase() + profile.last_name?.charAt(0).toUpperCase() : '?'

  return (
    <div style={s.root}>
      {/* Top bar */}
      <div style={s.topBar}>
        <div style={s.topLeft}>
          {showBack && <button onClick={onBack} style={s.backBtn}>←</button>}
          {screen === 'home' && (
            <div>
              <div style={s.greeting}>Welcome back,</div>
              <div style={s.name}>{profile?.first_name?.toUpperCase() || '...'}</div>
            </div>
          )}
        </div>
        <div style={s.topTitle}>{title}</div>
        <div style={s.topRight}>
          {screen === 'home' && (
            <div style={s.avatarWrap} onClick={() => onNavigate('profile')}>
              {profile?.avatar_url
                ? <img src={profile.avatar_url} alt="av" style={s.avatarImg} />
                : <div style={s.avatarInitials}>{initials}</div>}
            </div>
          )}
          <button style={{ ...s.menuBtn, marginLeft: 12 }} onClick={() => setMenuOpen(v => !v)}>☰</button>
        </div>
      </div>

      {/* Menu overlay */}
      {menuOpen && (
        <div style={s.menuOverlay} onClick={() => setMenuOpen(false)}>
          <div style={s.menuPanel} onClick={e => e.stopPropagation()}>
            <div style={s.menuHeader}>MENU</div>

            {/* My Profile */}
            <button style={s.menuItem} onClick={() => { onNavigate('profile'); setMenuOpen(false) }}>
              <span style={s.menuItemIcon}>👤</span>
              <div style={s.menuItemInfo}><div style={s.menuItemLabel}>My Profile</div></div>
              <span style={s.menuItemArrow}>→</span>
            </button>

            {/* Match Profiles — collapsible */}
            <button style={s.menuItem} onClick={() => setMatchProfilesOpen(v => !v)}>
              <span style={s.menuItemIcon}>🏅</span>
              <div style={s.menuItemInfo}><div style={s.menuItemLabel}>Match Profiles</div></div>
              <span style={s.menuItemArrow}>{matchProfilesOpen ? '▲' : '▼'}</span>
            </button>
            {matchProfilesOpen && (
              <button style={s.menuSubItem} onClick={() => { onNavigate('golf_profile'); setMenuOpen(false) }}>
                <span style={s.menuItemIcon}>⛳</span>
                <div style={s.menuItemInfo}>
                  <div style={s.menuItemLabel}>Golf Profile</div>
                  <div style={s.menuItemSub}>Handicap, stats & home course</div>
                </div>
                <span style={s.menuItemArrow}>→</span>
              </button>
            )}

            {/* Services — collapsible */}
            <button style={s.menuItem} onClick={() => setServicesOpen(v => !v)}>
              <span style={s.menuItemIcon}>🎓</span>
              <div style={s.menuItemInfo}><div style={s.menuItemLabel}>Services</div></div>
              <span style={s.menuItemArrow}>{servicesOpen ? '▲' : '▼'}</span>
            </button>
            {servicesOpen && (
              <div style={s.menuSubItem}>
                <span style={s.menuItemIcon}>⛳</span>
                <div style={s.menuItemInfo}>
                  <div style={s.menuItemLabel}>Golf Coach</div>
                  <div style={s.menuItemSub}>Coming soon</div>
                </div>
                <span style={s.menuItemSoon}>Soon</span>
              </div>
            )}

            {/* Friends */}
            <button style={s.menuItem} onClick={() => { onNavigate('friends'); setMenuOpen(false) }}>
              <span style={s.menuItemIcon}>👥</span>
              <div style={s.menuItemInfo}><div style={s.menuItemLabel}>Friends</div></div>
              <span style={s.menuItemArrow}>→</span>
            </button>

            {/* Betting Ledger */}
            <button style={s.menuItem} onClick={() => { onNavigate('betting_ledger'); setMenuOpen(false) }}>
              <span style={s.menuItemIcon}>📒</span>
              <div style={s.menuItemInfo}><div style={s.menuItemLabel}>Betting Ledger</div></div>
              <span style={s.menuItemArrow}>→</span>
            </button>

            {/* Wallet */}
            <button style={s.menuItem} onClick={() => { onNavigate('wallet'); setMenuOpen(false) }}>
              <span style={s.menuItemIcon}>◈</span>
              <div style={s.menuItemInfo}><div style={s.menuItemLabel}>Wallet</div></div>
              <span style={s.menuItemArrow}>→</span>
            </button>
            <button style={s.menuClose} onClick={() => setMenuOpen(false)}>Close</button>
          </div>
        </div>
      )}

      <div style={s.content}>{children}</div>

      {/* Bottom nav */}
      <div style={s.bottomNav}>
        {NAV_ITEMS.map(item => {
          const isActive = activeNav === item.id
          return (
            <button key={item.id} onClick={() => onNavigate(item.id)}
              style={{ ...s.navItem, ...(item.special ? s.navSpecial : {}) }}>
              {item.special
                ? <img src='/crossbet-logo.png' alt='Crossbet' style={{ width: 24, height: 24, objectFit: 'contain' }} />
                : <span style={{ fontSize: 18, color: isActive ? '#C19A6B' : '#555' }}>{item.icon}</span>}
              <span style={{ fontSize: 11, fontWeight: 600, color: item.special ? '#FFFFFF' : isActive ? '#C19A6B' : '#777', letterSpacing: 0.5 }}>
                {item.label}
              </span>
            </button>
          )
        })}
      </div>
    </div>
  )
}

const s = {
  root: { height: '100dvh', display: 'flex', flexDirection: 'column', fontFamily: "'DM Sans', sans-serif", background: '#FDF9E7', overflow: 'hidden' },
  topBar: { background: '#0A0A0A', paddingTop: 'calc(env(safe-area-inset-top) + 12px)', paddingBottom: 12, paddingLeft: 24, paddingRight: 24, display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexShrink: 0 },
  greeting: { fontSize: 11, color: '#999', letterSpacing: 1, textTransform: 'uppercase' },
  name: { fontFamily: "'Outfit', sans-serif", fontWeight: 800, fontSize: 16, color: '#FDF9E7', letterSpacing: 2 },
  avatarWrap: { width: 38, height: 38, borderRadius: 19, border: '2px solid #00563F', cursor: 'pointer', overflow: 'hidden', flexShrink: 0 },
  avatarImg: { width: '100%', height: '100%', objectFit: 'cover' },
  avatarInitials: { width: '100%', height: '100%', background: 'rgba(0,96,57,0.2)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 13, fontWeight: 700, color: '#00563F' },
  topLeft: { width: 40 },
  topRight: { width: 40, display: 'flex', justifyContent: 'flex-end' },
  backBtn: { background: 'none', border: 'none', color: '#C19A6B', fontSize: 24, cursor: 'pointer', padding: 0, lineHeight: 1 },
  topTitle: { fontFamily: "'Outfit', sans-serif", fontWeight: 800, fontSize: 22, color: '#FDF9E7', letterSpacing: 6, textAlign: 'center' },
  menuBtn: { background: 'none', border: 'none', color: '#C19A6B', fontSize: 22, cursor: 'pointer', padding: 0, lineHeight: 1 },
  menuOverlay: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)', zIndex: 200, display: 'flex', justifyContent: 'flex-end' },
  menuPanel: { background: '#0A0A0A', width: 280, display: 'flex', flexDirection: 'column', padding: '60px 0 32px', gap: 4 },
  menuHeader: { fontFamily: "'Outfit', sans-serif", fontWeight: 700, fontSize: 22, color: '#FDF9E7', letterSpacing: 3, padding: '0 24px 16px', borderBottom: '1px solid #1E1E1E' },
  menuItem: { display: 'flex', alignItems: 'center', gap: 14, padding: '14px 24px', background: 'none', border: 'none', cursor: 'pointer', fontFamily: 'inherit', width: '100%', textAlign: 'left' },
  menuItemIcon: { fontSize: 20, width: 28, flexShrink: 0 },
  menuItemInfo: { flex: 1 },
  menuItemLabel: { fontSize: 15, fontWeight: 600, color: '#FDF9E7' },
  menuItemSub: { fontSize: 11, color: '#555', marginTop: 2 },
  menuItemArrow: { fontSize: 16, color: '#C19A6B' },
  menuItemSoon: { fontSize: 10, fontWeight: 700, color: '#555', background: '#1E1E1E', borderRadius: 6, padding: '3px 8px' },
  menuSubItem: { display: 'flex', alignItems: 'center', gap: 14, padding: '12px 24px 12px 40px', background: 'rgba(255,255,255,0.04)', border: 'none', cursor: 'pointer', fontFamily: 'inherit', width: '100%', textAlign: 'left' },
  menuSectionHeader: { fontSize: 10, fontWeight: 700, color: '#444', letterSpacing: 2, padding: '12px 24px 4px', textTransform: 'uppercase' },
  menuClose: { margin: '16px 24px 0', background: 'transparent', border: '1px solid #333', borderRadius: 12, padding: '12px', color: '#555', fontSize: 14, cursor: 'pointer', fontFamily: 'inherit' },
  content: { flex: 1, overflowY: 'auto' },
  bottomNav: { background: '#0A0A0A', borderTop: '1px solid #1E1E1E', display: 'flex', alignItems: 'center', justifyContent: 'space-around', flexShrink: 0, paddingTop: 10, paddingBottom: 'calc(env(safe-area-inset-bottom) + 8px)' },
  navItem: { background: 'none', border: 'none', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4, cursor: 'pointer', padding: '4px 8px' },
  navSpecial: { background: 'linear-gradient(135deg,#00563F,#006B4D)', borderRadius: 16, padding: '10px 16px', marginTop: -16 },
}
